module.exports = __webpack_public_path__ + "static/media/nestle.0c6a4ed5.svg";